import React from 'react'

import './index.css'
import classNames from 'classnames'

function BannerImage({ header, bannerGradientClass, children }) {
    return (
        <div
            className={classNames('backGrndImage gradient-overlay', bannerGradientClass, {
                noHeader: header === false,
            })}
        >
            <div style={{ zIndex: 999 }}>{children}</div>
        </div>
    )
}

export default BannerImage
